import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import styles from '../../../styles/bantrab/components/input.module.scss'

const Password = ({ inputType, placeholder, icon, iconEyeOff, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.password]: true
  })

  return (
    <div {...attrs}>
      <Typography>
        <input className="pl-4 pr-11" type={inputType} placeholder={placeholder} />
      </Typography>
      <figure className="eye-icon flex items-center right-4" onClick={event => {
        const input = event.currentTarget.previousSibling.querySelector('input')
        input.type = input.type === 'password' ? 'text' : 'password'

        const icons = event.currentTarget.querySelectorAll('svg')
        icons.forEach(item => item.classList.toggle('hidden'))
      }} >
        {iconEyeOff}
        {icon}
      </figure>
    </div>
  )
}

Password.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconEyeOff: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inputType: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default Password
